import { useMutation } from 'react-query'
import { useForm } from 'react-hook-form'
import { api } from '../../../../services/api'
import { useToast } from '@chakra-ui/react'

export function useResetarCompreGanhe() {
  const toast = useToast()

  const {
    register,
    handleSubmit: hookFormSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      numero_pedido: '',
    },
  })

  const resetCompreGanheMutation = useMutation(
    async (data) => {
      return await api.get('/site/v2/crm-controle/resetar-link-compre-ganhe', {
        params: {
          numero_pedido: data.numero_pedido,
        },
      })
    },
    {
      onSuccess: () => {
        toast({
          title: 'Sucesso!',
          description: 'Link do Compre e Ganhe resetado com sucesso!',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        })
        reset()
      },
      onError: (error) => {
        toast({
          title: 'Erro',
          description: error.response?.data?.message || 'Erro ao resetar link do Compre e Ganhe. Verifique o número do pedido.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        })
      },
    }
  )

  const onSubmit = hookFormSubmit(async (data) => {
    await resetCompreGanheMutation.mutateAsync(data)
  })

  return {
    register,
    onSubmit,
    errors,
    isLoading: resetCompreGanheMutation.isLoading,
  }
}
